import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Rating,
  Typography,
  Alert,
} from "@mui/material";
import { useState } from "react";
import api from "../services/api";
import { valueVerification } from "../utils/utils";

const FeedbackModal = ({ open, onClose }) => {
  const [tipoFeedback, setTipoFeedback] = useState("");
  const [avaliacao, setAvaliacao] = useState(0);
  const [comentario, setComentario] = useState("");
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState(false);

  const tiposFeedback = [
    { value: 0, label: "Nova Funcionalidade" },
    { value: 1, label: "Melhoria" },
    { value: 2, label: "Crítica Construtiva" },
    { value: 3, label: "Elogio" },
  ];

  const handleEnviar = async () => {
    if (valueVerification(tipoFeedback) || !avaliacao || !comentario.trim()) {
      setErro("Por favor, preencha todos os campos");
      return;
    }

    if (comentario.trim().length < 5) {
      setErro("O comentário deve ter pelo menos 5 caracteres.");
      return;
    }

    setLoading(true);
    setErro("");

    try {
      await api.post("/Feedback", {
        Tipo: tipoFeedback,
        Avaliacao: avaliacao,
        Comentario: comentario,
      });

      setSucesso(true);
      setTimeout(() => {
        handleFechar();
      }, 2000);
    } catch (error) {
      const validationErrors = error.response?.data?.errors;
      const firstError = validationErrors
        ? Object.values(validationErrors).flat()[0]
        : null;
      setErro(
        firstError ||
          error.response?.data?.message ||
          error.message ||
          "Erro ao enviar feedback",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFechar = () => {
    setTipoFeedback("");
    setAvaliacao(0);
    setComentario("");
    setErro("");
    setSucesso(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleFechar} maxWidth="sm" fullWidth>
      <DialogTitle>Enviar Feedback</DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        {sucesso && (
          <Alert severity="success" sx={{ mb: 2 }}>
            Obrigado pelo seu feedback!
          </Alert>
        )}

        {erro && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {erro}
          </Alert>
        )}

        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <FormControl fullWidth>
            <InputLabel>Tipo de Feedback</InputLabel>
            <Select
              value={tipoFeedback}
              onChange={(e) => setTipoFeedback(e.target.value)}
              label="Tipo de Feedback"
              disabled={loading}
            >
              {tiposFeedback.map((tipo) => (
                <MenuItem key={tipo.value} value={tipo.value}>
                  {tipo.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
            <Typography variant="subtitle2">Avaliação do Sistema</Typography>
            <Rating
              value={avaliacao}
              onChange={(e, newValue) => setAvaliacao(newValue)}
              disabled={loading}
              sx={{
                fontSize: "3.5rem",
                "& .MuiRating-icon": {
                  fontSize: "3.5rem",
                },
              }}
            />
          </Box>

          <TextField
            label="Seu Comentário"
            multiline
            rows={4}
            fullWidth
            value={comentario}
            onChange={(e) => setComentario(e.target.value)}
            placeholder="Compartilhe seu feedback conosco..."
            disabled={loading}
            variant="outlined"
            inputProps={{ minLength: 5, maxLength: 1000 }}
            helperText={`${comentario.length}/1000 (mínimo 5 caracteres)`}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleFechar} disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={handleEnviar}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? "Enviando..." : "Enviar Feedback"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackModal;
